import ComponentLoader from "@ch/components/Loaders/ComponentLoader";
import type { FC } from "react";
import { Navigate, useMatch } from "react-router-dom";
import useKemGate, { type KemGateTarget } from "../hooks/useKemGate";
import useKemWarmUp from "../hooks/useKemWarmUp";

interface Props {
  requiredTarget: KemGateTarget;
  children: React.ReactNode;
}

const KemRouteGuard: FC<Props> = ({ requiredTarget, children }) => {
  useKemWarmUp();
  const kemGate = useKemGate();
  const target = kemGate.target;
  const hasCheckedHealth = kemGate.hasCheckedHealth;
  const isOnKemICRoute = useMatch({ path: "/kem/ic", end: true }) !== null;

  if (!hasCheckedHealth) {
    return <ComponentLoader />;
  }

  if (requiredTarget === "ic" && isOnKemICRoute) {
    return children;
  }

  if (target !== requiredTarget) {
    return <Navigate replace to={`/kem/${target}`} />;
  }

  return children;
};

export default KemRouteGuard;
